export default __webpack_public_path__ + "static/media/niceImage.7675097c.svg";